export const serviceTypes = {
  LENS: 'lens',
  REMOTE_CONTROL: 'remote-control'
};

export enum ServiceTypes {
  ALL = '0',
  CHATS = '1',
  EMAILS = '3',
  SMS = '9',
  FACEBOOK = '13',
  ASYNC_MESSAGE = '15',
  OMNI = '16'
}

export interface ServiceTypeModel {
  serviceType: ServiceTypes;
}
